import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useRef, useState } from "react";
import { StationMarker } from "./StationMarker";
var createClusterMarkerSvg = function(number, position) {
    var circleData = [
        {
            radius: 12,
            opacity: 1
        },
        {
            radius: 16,
            opacity: 0.5
        },
        {
            radius: 19,
            opacity: 0.3
        }, 
    ];
    var svgMarker = '\n    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">\n      '.concat(circleData.map(function(param) {
        var radius = param.radius, opacity = param.opacity;
        return '\n        <circle cx="20" cy="20" r="'.concat(radius, '" fill="#00977d" fill-opacity="').concat(opacity, '" />\n      ');
    }).join(""), '\n      <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" fill="#ffffff" font-size="14">').concat(number, "</text>\n    </svg>\n  ");
    var svgUrl = "data:image/svg+xml;base64,".concat(btoa(svgMarker));
    var marker = new google.maps.Marker({
        position: position,
        icon: {
            url: svgUrl,
            scaledSize: new google.maps.Size(40, 40)
        }
    });
    return marker;
};
var customRenderer = {
    render: function(param) {
        var count = param.count, position = param.position;
        return createClusterMarkerSvg(count, position);
    }
};
export var Markers = function(param) {
    var select = param.select, selected = param.selected, stations = param.stations;
    var map = useMap();
    var clusterer = useRef(null);
    var ref = useState({}), markers = ref[0], setMarkers = ref[1];
    useEffect(function() {
        if (!map) return;
        if (!clusterer.current) {
            clusterer.current = new MarkerClusterer({
                map: map,
                renderer: customRenderer
            });
        }
    }, [
        map
    ]);
    useEffect(function() {
        var ref, ref1;
        (ref = clusterer.current) === null || ref === void 0 ? void 0 : ref.clearMarkers();
        (ref1 = clusterer.current) === null || ref1 === void 0 ? void 0 : ref1.addMarkers(Object.values(markers));
    }, [
        markers
    ]);
    var setMarkerRef = function(marker, key) {
        if (marker && markers[key]) return;
        if (!marker && !markers[key]) return;
        setMarkers(function(prev) {
            if (marker) {
                return _object_spread_props(_object_spread({}, prev), _define_property({}, key, marker));
            }
            var newMarkers = _object_spread({}, prev);
            delete newMarkers[key];
            return newMarkers;
        });
    };
    var makeHandleSelect = function(stationId, stationKind) {
        return function() {
            return select(stationId, stationKind);
        };
    };
    return stations ? /*#__PURE__*/ _jsx(_Fragment, {
        children: stations.map(function(station) {
            return /*#__PURE__*/ _jsx(StationMarker, {
                setMarkerRef: setMarkerRef,
                station: station,
                deselect: makeHandleSelect(null, null),
                select: makeHandleSelect(station.id, station.stationKind),
                selected: selected === station.id
            }, station.id);
        })
    }) : null;
};
